// The Dwyer reading is an unsigned 12-bit ADC value. This value is first converted to volts and then to pressure in PSIG. The ConversionFormulaScale parameter is used to scale the pressure value for the particular sensor. Convert the 12-bit value ($rdg in code below) to pressure ($prs in code below) using the following algorithm:

/*
$prs = 0.0;
if ( $rdg == 0xFFF )
{
  $prs = null; // display reading as “invalid”
}
else
{
  $kfactor = (float)$ConversionFormulaScale;
  $volt = ((float)$rdg)/327.6;
  $amp = $volt / 250.0;
  $prs = $kfactor * ($amp - 0.004) / (0.016);
}
*/

export function dwyer(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  const kfactor = scale
  const voltage = reading / 327.6
  const amp = voltage / 250.0

  return (kfactor * (amp - 0.004)) / 0.016
}
